import { render, staticRenderFns } from "./QuoteDocuments.vue?vue&type=template&id=0b8b8016"
import script from "./QuoteDocuments.vue?vue&type=script&lang=js"
export * from "./QuoteDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports